module.exports = __webpack_public_path__ + "4e1cb3055ec8aa56df85adb6af907fb7.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/futura_book/futura_book.ttf
// module id = 915
// module chunks = 0